import { Controller } from "@hotwired/stimulus"

const MIN_SCALE = 1
const MAX_SCALE = 4
const SCALE_STEP = 0.25

const OFFSETS = {
  0: () => [0, 0],
  90: (width) => [width, 0],
  180: (width, height) => [width, height],
  270: (width, height) => [0, height],
}

export default class extends Controller {
  static targets = ["viewport", "canvas", "image", "scale"]

  connect() {
    this.reset()
  }

  zoomIn() {
    this.scale = Math.min(MAX_SCALE, this.scale + SCALE_STEP)
    this.apply()
  }

  zoomOut() {
    this.scale = Math.max(MIN_SCALE, this.scale - SCALE_STEP)
    this.apply()
  }

  rotate() {
    this.rotation = (this.rotation + 90) % 360
    this.apply()
  }

  reset() {
    this.scale = MIN_SCALE
    this.rotation = 0
    this.apply()
  }

  apply() {
    if (this.hasScaleTarget) this.scaleTarget.textContent = `${Math.round(this.scale * 100)}%`

    const { naturalWidth, naturalHeight } = this.imageTarget
    if (!naturalWidth || !naturalHeight) return

    const sideways = this.rotation % 180 !== 0
    const [boundWidth, boundHeight] = sideways ? [naturalHeight, naturalWidth] : [naturalWidth, naturalHeight]
    const fit = Math.min(1, this.viewportTarget.clientWidth / boundWidth, this.viewportTarget.clientHeight / boundHeight)
    const width = naturalWidth * fit * this.scale
    const height = naturalHeight * fit * this.scale
    const [canvasWidth, canvasHeight] = sideways ? [height, width] : [width, height]
    const [offsetX, offsetY] = OFFSETS[this.rotation](canvasWidth, canvasHeight)

    this.canvasTarget.style.width = `${canvasWidth}px`
    this.canvasTarget.style.height = `${canvasHeight}px`
    this.imageTarget.style.width = `${width}px`
    this.imageTarget.style.height = `${height}px`
    this.imageTarget.style.transform = `translate(${offsetX}px, ${offsetY}px) rotate(${this.rotation}deg)`
  }
}
